import { styled } from '@creditas-ui/react'

export const Container = styled.div`
  display: flex;
  margin: 8em auto;
  text-align: center;
  align-items: center;
  justify-content: center;
`
